// Constantes du site : coordonnées, versions, identité de l'éditeur et de
// l'hébergeur. Les pages de l'app lisent ces valeurs ici au lieu de les écrire en
// dur — changer une adresse ou une version se fait à cet endroit seulement.
//
// ⚠️ Le site vitrine (`website/`) a son propre build Docker et ne peut pas
// importer ce fichier : ses pages légales (mentions légales, CGU, confidentialité)
// reprennent les mêmes valeurs, à reporter à la main. Côté back, l'e-mail de
// contact de l'OpenAPI (`app/main.py`) et l'expéditeur des mails (`MAIL_FROM`,
// `app/core/email.py`) sont aussi définis à part.

export const APP_NAME = 'CycleGala';

// Affichée en bas du profil et de l'écran de connexion. Suit la version Helm
// (`appVersion` de `cyclegala-deploy/helm/Chart.yaml`), à reporter à la main.
export const APP_VERSION = '0.2.16';

// Version et date des documents légaux affichés dans l'application.
//
// Source : `Avocat/DOCUMENTS/consentement doc/Notice_CycleGala_RGPD_V2.3.docx`
// (Cabinet LexIC), « Version 1, 25/06/2026 ».
//
// ⚠️ `LEGAL_VERSION` doit rester alignée avec `CONSENT_VERSION` dans
// `app/core/legal.py`, enregistrée au moment de l'inscription : c'est elle qui
// matérialise la preuve de consentement. Toute modification substantielle de la
// notice impose d'incrémenter les deux ET de recueillir à nouveau le consentement
// (notice §12).
export const LEGAL_VERSION = '1.0';
export const LEGAL_UPDATED_AT = '25 juin 2026';

// Domaines publics : l'app (SPA + /api) et le site vitrine. Miroir de `appDomains`
// et `global.domain` dans `cyclegala-deploy/helm/values.yaml`.
export const APP_URL = 'https://cyclegala.app';
export const SITE_URL = 'https://cyclegala.fr';

// Contact général, support, et référent protection des données (CGU art. 1,
// politique de confidentialité §1 et §10).
export const CONTACT_EMAIL = 'contact@cyclegala.fr';

// Éditeur (CGU art. 1, politique de confidentialité §1, courrier du référent).
export const EDITEUR = {
  nom: 'GEHB',
  forme: 'Société par Actions Simplifiée',
  capital: '10 000 €',
  rcsVille: 'Brest',
  rcsNumero: '107 677 106',
  siege: '9 boulevard Jean Moulin, 29200 Brest',
};

// Hébergeur des données de santé (politique de confidentialité §6).
export const HEBERGEUR = {
  nom: 'Asten Cloud',
  siret: '32378999000112',
  adresse: '26 rue Gaston Planté, 29850 Gouesnou, France',
};
